import get from 'lodash/get';
import toArray from 'lodash/toArray';
import forEach from 'lodash/forEach';
import keyBy from 'lodash/keyBy';
import flatten from 'lodash/flatten';

function validateDialogueControls(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));

  const questions = get(caseConf, 'dialogue.questions', []);
  const commands = get(caseConf, 'dialogue.commands', []);
  const unsolicited = get(caseConf, 'dialogue.unsolicited', []);
  const callItems = flatten((get(caseConf, 'dialogue.calls') || []).map(call => call.items))
  const callUnsolicited = flatten((get(caseConf, 'dialogue.calls') || []).map(call => call.unsolicited))
  const questionsById = keyBy(questions, 'id');
  const commandsById = keyBy(commands, 'id');
  const unsolicitedById = keyBy(unsolicited, 'id');
  const callItemsById = keyBy(callItems, 'id');
  const callUnsolicitedById = keyBy(callUnsolicited, 'id');
  const errors = [];
  const warnings = [];

  const dialogueItemsByTypeById = {
    QUESTION: questionsById,
    ANSWER: questionsById,
    COMMAND: commandsById,
    COMMAND_COUNT: commandsById,
    UNSOLICITED_DIALOGUE: unsolicitedById,
    UNSOLICITED_CALL: callUnsolicitedById,
    CALL: callItemsById,
    CALL_ANSWER: callItemsById,
  }
  const dialogueTitleByType = {
    QUESTION : 'Question',
    ANSWER: 'Question',
    COMMAND: 'Command',
    COMMAND_COUNT: 'Command',
    UNSOLICITED_DIALOGUE: 'Unsolicited',
    UNSOLICITED_CALL: 'Unsolicited',
    CALL: 'Call dialogue',
    CALL_ANSWER: 'Call dialogue',
  }

  // Action nodes
  const actionNodes = nodes.filter(node => node.name === 'Action');
  const dialogueActionTypes = ['QUESTION', 'COMMAND', 'CALL'];

  actionNodes.forEach((node) => {
    const action = get(node, 'data.action');
    if (action && dialogueActionTypes.includes(action.type)) {
      const dialogueTitle = dialogueTitleByType[action.type];
      if (!action.id) {
        errors.push(caseLogicError(`You need to select a ${dialogueTitle.toLowerCase()}`, node.id, undefined));
        return;
      }
      const dialogueItem = dialogueItemsByTypeById[action.type][action.id];
      if (!dialogueItem) {
        const label = get(dialogueItem, 'content.en', action.id);
        errors.push(questionError(`${dialogueTitle} "${label}" is used in case logic but could not be found`, action.id, undefined));
        errors.push(caseLogicError(`${dialogueTitle} could not be found`, node.id, undefined));
      }
    }
  });

  // Effect nodes
  const effectNodes = nodes.filter(node => node.name === 'Effect');
  const dialogueEffectTypes = ['QUESTION', 'ANSWER', 'COMMAND', 'CALL', 'CALL_ANSWER', 'UNSOLICITED_DIALOGUE', 'UNSOLICITED_CALL'];

  effectNodes.forEach((node) => {
    const effect = get(node, 'data.effect');
    if (effect && dialogueEffectTypes.includes(effect.type)) {
      const dialogueTitle = dialogueTitleByType[effect.type];
      if (!effect.id) {
        errors.push(caseLogicError(`You need to select a ${dialogueTitle.toLowerCase()}`, node.id, undefined));
        return;
      }
      const dialogueItem = dialogueItemsByTypeById[effect.type][effect.id];
      if (!dialogueItem) {
        const label = get(dialogueItem, 'content.en', effect.id);
        errors.push(questionError(`${dialogueTitle} "${label}" is used in case logic but could not be found`, effect.id, undefined));
        errors.push(caseLogicError(`${dialogueTitle} could not be found`, node.id, undefined));
      }
    }
  });


  // Check nodes
  const checkNodes = nodes.filter(node => node.name === 'Check');
  const dialogueCheckTypes = ['QUESTION', 'COMMAND_COUNT', 'UNSOLICITED_DIALOGUE', 'CALL', 'UNSOLICITED_DIALOGUE'];

  checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if (dialogueCheckTypes.includes(check.type)) {
        const dialogueTitle = dialogueTitleByType[check.type];
        if (!check.id) {
          errors.push(caseLogicError(`You need to select a ${dialogueTitle.toLowerCase()}`, node.id, undefined));
          return;
        }
        const dialogueItem = dialogueItemsByTypeById[check.type][check.id];
        if (!dialogueItem) {
          errors.push(questionError(`${dialogueTitle} "${check.id}" is used in case logic but could not be found`, check.id, undefined));
          errors.push(caseLogicError(`${dialogueTitle} could not be found`, node.id, checkKey));
        }
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

function questionError(message, actionId, componentId) {
  return {
    message,
    category: 'dialogue',
    field: 'dialogue',
    id: actionId,
    metadata: {
      componentId,
      scope: 'control',
    },
  };
}

function caseLogicError(message, nodeId, checkKey, componentId) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: nodeId,
    metadata: {
      checkKey,
      componentId,
      scope: 'control',
    },
  };
}

export default validateDialogueControls;
